import _typeof from "@babel/runtime/helpers/typeof";
import { allowParamOmit } from "./allowParamOmit";
import { withRenderFlag } from "./withRenderFlag";
var shouldRenderFn = function shouldRenderFn() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && !!window.document && !!document.createElement;
};
export var withClientRendering = allowParamOmit(function () {
  var fallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return withRenderFlag({
    fallback: fallback,
    shouldRenderFn: shouldRenderFn
  });
});